import { personal_details } from '@flows/configs/shared/steps/personal_details'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnySteps } from '@flows/core/types/stepTypes'

import dog_list from './dogList'
import dog_damages from './dog_damages'
import dog_insurance_cancelled from './dog_insurance_cancelled'
import dog_owner_age from './dog_owner_age'
import dog_previously_owned from './dog_previously_owned'
import dog_quote from './dog_quote'
import dog_sos_help from './dog_sos_help'

const getDogLiabilityNxtSteps = (params: StepConfigParams) =>
  ({
    dog_list: dog_list(params),
    dog_owner_age: dog_owner_age(params),
    dog_previously_owned: dog_previously_owned(params),
    dog_damages: dog_damages(params),
    dog_insurance_cancelled: dog_insurance_cancelled(params),
    dog_sos_help: dog_sos_help(params),
    dog_quote: dog_quote(params),
    dog_liability_personal_details: personal_details(params, {
      nextStep: 'gender',
      omitFields: ['birthdate'],
      policyPreviewConsent: {
        titleKey: 'sharedFlows_dogLiabilityNxt:steps.personal_details.policyPreview.title',
        textKey: 'sharedFlows_dogLiabilityNxt:steps.personal_details.policyPreview.text',
      },
      translations: {
        title: 'sharedFlows_common:steps.personal_details.title',
        birthdateLabel: 'sharedFlows_common:steps.personal_details.birthdate.input.label',
        marketingOptIn: 'sharedFlows_common:steps.email_and_name.checkboxes.marketingOptIn',
        minAgeError: 'sharedFlows_common:generic.errors.min_age',
        maxAgeError: 'sharedFlows_common:generic.errors.max_age',
      },
    }),
  }) as const satisfies AnySteps

export default getDogLiabilityNxtSteps
